import React, {Component, Fragment} from 'react';

class CreateExpression extends Component {
  handleSelectType(type) {
    const {variables, onChange} = this.props;

    switch(type) {
      case 'LOGIC':
        onChange({'and': [null, null]});
        break;
      case 'COMPARE':
        onChange({'==': [null, null]});
        break;
      case 'DATETIME_COMPARE':
        onChange({'datetime_after': [
          {'var': Object.keys(variables).filter(key => variables[key].type === 'DATETIME')[0]},
          null
        ]});
        break;
      case 'FORMULA':
        onChange({'+': [null, null]});
        break;
      case 'VARIABLE':
        onChange({'var': Object.keys(variables)[0]});
        break;
      case 'VALIDATION':
        onChange({'!': [null]});
        break;
      case 'OPTIONS':
      case 'STATIC_TEXT':
        onChange("");
        break;
      case 'STATIC_NUMBER':
        onChange(0);
        break;
      case 'STATIC_BOOLEAN':
        onChange(true);
        break;
      default:
        throw new Error(`Unknown expression type: ${type}`);
    }
  }

  render() {
    const {variables, options} = this.props;

    return (
      <select onChange={e => this.handleSelectType(e.target.value)}>
        <option value={null}>Choose an expression...</option>
        <option value="LOGIC">Logic operation</option>
        <option value="COMPARE">Value comparison</option>
        <option value="VALIDATION">Validation</option>
        {variables && Object.keys(variables).filter(key => variables[key].type === 'DATETIME').length > 0 ? (
          <option value="DATETIME_COMPARE">Date/Time comparison</option>
        ) : null}
        <option value="FORMULA">Math formula</option>
        {variables && Object.keys(variables).length > 0 ? (
          <option value="VARIABLE">Variable</option>
        ) : null}
        {options && options.length > 0 ? (
          <option value="OPTIONS">Options</option>
        ): (
          <Fragment>
            <option value="STATIC_TEXT">Text</option>
            <option value="STATIC_NUMBER">Number</option>
            <option value="STATIC_BOOLEAN">True or false</option>
          </Fragment>
        )}
      </select>
    )
  }
}

export default CreateExpression;
